// src/app/app.component.ts
import { Component } from '@angular/core';
import { AuthService } from './core/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'servitrack';
   isSidebarCollapsed = false;

  constructor(public authService: AuthService) {}

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  async handleLogout(): Promise<void> {
    await this.authService.logout();
  }
}